import { Modal } from 'component-library';
import { type NewContainer } from '@sr/types';
import { AddContainer } from './AddContainer';

export const AddContainerModal = ({
  showModal,
  isOpen,
  editNewContainer,
  locationDwKey,
  onSave,
  useGrandParentLocation,
}: {
  showModal: (isOpen: boolean) => void;
  isOpen: boolean;
  editNewContainer?: NewContainer;
  locationDwKey: string;
  onSave: (container: NewContainer) => void;
  useGrandParentLocation?: boolean;
}) => {
  const handleAbortModal = () => {
    showModal(false);
  };

  const handleSaveContainer = (container: NewContainer) => {
    onSave(container);
    showModal(false);
  };

  return (
    <Modal
      open={isOpen}
      closeOnEscape={false}
      closeOnClickOutside={false}
      onClose={() => {
        showModal(false);
        handleAbortModal();
      }}
    >
      <AddContainer
        container={editNewContainer}
        onSave={handleSaveContainer}
        locationDwKey={locationDwKey}
        handleAbortModal={handleAbortModal}
        useGrandParentLocation={useGrandParentLocation}
      />
    </Modal>
  );
};
